<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div
    class="my-6 flex before:h-px before:w-full before:bg-hazel-200 after:h-px after:bg-hazel-500"
  ></div>
</template>
